import {
  gql 
} from "@apollo/client"
export const GET_REVIEWPAGE_QUERY = gql`
    query getAllReviews(
        $category_id: String
        $currentPage: Int!
        $pageSize: Int!
    ) {
        allReviews(
            filter: { category_id: { eq: $category_id } }
            currentPage: $currentPage
            pageSize: $pageSize
        ) {
            items {
                id
                product {
                    name
                    uid
                    url_key
                    small_image {
                        url(type: "thumbnail", width: 320, height: 470)
                    }
                }
                nickname
                summary
                text
                created_at
                review_image {
                    id
                    url
                    __typename
                }
                review_helpful {
                    items {
                        id
                        is_help
                        is_not_help
                        is_owner
                        __typename
                    }
                    is_help_count
                    is_not_help_count
                }
                average_rating
                fitness
                body_type
                size
            }
            page_info {
                page_size
                current_page
                total_pages
            }
            total_count
            categories {
                id
                name
                count
            }
        }
    }
`
export default {
  getReciewPageQuery: GET_REVIEWPAGE_QUERY,
}
